<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_button">
        <el-button v-if="addClassification" type="primary" size="small" @click="addstamp">
          新增分类
        </el-button>
        <el-button v-if="addSubClassification" type="primary" size="small" @click="addsonStamp">
          新增子分类
        </el-button>
        <el-button v-if="editClassification" type="primary" size="small" plain @click="updateStamp">
          修改
        </el-button>
        <el-button v-if="deleClassification" type="danger" plain size="small" @click="deletestamp">
          删除
        </el-button>
      </div>
      <div class="left_tree">
        <el-tree ref="depTree" :data="frameTree" :accordion="true" :props="defaultProps"
          :default-expanded-keys="defaultExpandedKeys" class="tree_1" highlight-current node-key="sortID"
          @current-change="currentOrgChangeHandler">
          <template #default="{ data }">
            <span style="font-size:14px">
              {{ data.sortName }}[{{ data.sortCode }}]
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_button">
        <el-upload :show-file-list="false" :http-request="httpRequest" :disabled="!sortID" action="/"
          accept="image/gif,image/jpeg,image/jpg,image/bmp,image/png" style="display: inline-block; margin: 0 8px 0 0">
          <el-button v-if="uploadStamp" icon="el-icon-upload2" size="small" type="primary" plain>
            上传
          </el-button>
        </el-upload>
        <el-button v-if="downStamp" :disabled="!sortID" size="small" type="primary" plain @click="download">
          下载
        </el-button>
        <el-button v-if="deleStamp" :disabled="!sortID" size="small" type="danger" plain @click="deleteStaBtn">
          删除
        </el-button>
        <el-button :disabled="!sortID" size="small" type="primary" plain @click="cerClick">
          关联证书
        </el-button>
      </div>
      <div>
        <div class="right_bottom">
          <img v-if="isStamp == 1" :src="imageUrl" alt="" style="height:100%" />
        </div>
        <div v-if="isCertificate" class="bottom-certificate">
          <p class="certificate-style">已关联证书名称：<span>{{ formInfo.signName }}</span></p>
          <p class="certificate-style">证书有效期：<span>{{ formInfo.effectiveDate }}</span></p>
          <p class="certificate-button">
            <el-button type="text" size="small" @click="cerClick">【更新证书】</el-button>
            <el-button type="text" style="color:orangered;" size="small" @click="cerDelClick">【删除证书】</el-button>
          </p>
          <p></p>
          <p></p>
        </div>
      </div>
    </div>
    <!-- 增加 修改 -->
    <el-dialog v-dialogDrag :title="stampTitle" :visible.sync="editPersonDialog" :before-close="getEditPersonClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="图章分类ID" prop="sortCode">
          <el-input ref="sortCode" v-model="form.sortCode" maxlength="20" show-word-limit size="small" />
        </el-form-item>
        <el-form-item label="图章名称" prop="sortName">
          <el-input v-model="form.sortName" maxlength="20" show-word-limit size="small" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getEditPersonClose">取 消</el-button>
        <el-button v-if="submitType != 2" type="primary" size="small" @click="getstampBtn">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="updatestampBtn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="上传证书"
      :visible.sync="certificateDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      :before-close="handleClose">
      <el-form ref="formData" :model="formData" :rules="rulesC" label-width="100px" size="small">
        <el-form-item label="选择证书" prop="fileName">
          <el-upload v-if="!formData.fileName" :show-file-list="false" :http-request="httpUploadSign" :disabled="!sortID" action="/"
            accept=".PFX" style="display: inline-block; margin: 0 10px">
            <el-button size="small" type="primary" plain>
              导入
            </el-button>
          </el-upload>
          <div v-else>{{ formData.fileName }}</div>
        </el-form-item>
        <el-form-item label="证书密码" prop="password">
          <el-input v-model="formData.password" style="width:90%;" size="small" show-password />
        </el-form-item>
        <el-form-item v-if="isShow" label="证书有效期至">
          <el-input v-model="formData.effectiveDate" size="small" style="width:90%;" readonly />
        </el-form-item>
        <el-form-item v-if="isShow" label="颁发给">
          <el-input v-model="formData.issue" size="small" style="width:90%;" readonly />
        </el-form-item>
        <el-form-item>
          <el-button type="text" size="small" @click="passwordClick">【验证证书】</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="certificateSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import stamp from "@/CommonDP/service/eSeal-service";
import tzService from "@/CommonDP/service/tz-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import password from "@/CommonDP/pages/password/index.vue";
const newForm = () => ({
  sortCode: "",
  sortName: ""
});
export default {
  name: "Stamp",
  data() {
    return {
      defaultProps: {
        children: "treeList",
        label: "sortName"
      },
      frameTree: [], // 树
      defaultExpandedKeys: [],
      form: newForm(),
      rules: {
        sortCode: [{ required: true, message: "图章分类ID必填", trigger: "blur" }],
        sortName: [{ required: true, message: "图章名称必填", trigger: "blur" }]
      },
      rulesC: {
        fileName: [{ required: true, message: "选择证书", trigger: "blur" }],
        password: [{ required: true, message: "证书密码", trigger: "blur" }]
      },
      formData: {
        fileId: '',
        password: '',
        effectiveDate: '',
        issue: '',
        fileName: ''
      },
      formInfo: {
        signName: '',
        signId: '',
        effectiveDate: ''
      },
      valData: {},
      isShow: false,
      isCertificate: false,
      editPersonDialog: false,
      certificateDialog: false,
      sortID: undefined,
      pID: undefined,
      submitType: "",
      currentRow: {},
      upload: false,
      imageUrl: "",
      isStamp: undefined,
      addClassification: checkPermission(this.$allPerms.STAMP_ADDCLASSIFICATION),
      addSubClassification: checkPermission(this.$allPerms.STAMP_ADDSUBCLASSIFICATION),
      editClassification: checkPermission(this.$allPerms.STAMP_EDITCLASSIFICATION),
      deleClassification: checkPermission(this.$allPerms.STAMP_DELECLASSIFICATION),
      uploadStamp: checkPermission(this.$allPerms.STAMP_UPLOAD),
      downStamp: checkPermission(this.$allPerms.STAMP_DOWN),
      deleStamp: checkPermission(this.$allPerms.STAMP_DALE)
    };
  },
  computed: {
    password() {
      return password;
    },
    stampTitle() {
      return ["图章分类信息", "图章子分类信息", "修改图章分类信息"][this.submitType];
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    imageUrl(newValue, oldValue) {
      if (oldValue) {
        URL.revokeObjectURL(oldValue);
      }
    }
  },
  created() {
    this.getFrameTree();
  },
  methods: {
    cerClick() {
      this.certificateDialog = true;
      this.isShow = false;
      this.formData = {
        fileId: '',
        password: '',
        effectiveDate: '',
        issue: '',
        fileName: ''
      };
    },
    // 删除关联证书
    cerDelClick() {
      this.$confirm(`此操作将删除图章绑定的证书，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await stamp.getDeleteSignFile({ sortId: this.sortID });
        this.$message.success('删除成功');
        this.isCertificate = false;
        // await this.getFrameTree();
      }).catch((e) => {
        console.log(e);
      });
    },
    // 关联证书 取消
    handleClose() {
      this.certificateDialog = false;
    },
    // 关联证书 确认
    async certificateSave() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          if (!this.isShow) {
            this.$message.error('请验证证书');
            return;
          }
          if (this.isStamp !== 1) {
            this.$message.error('没有图章，请先上传');
            return;
          }
          const params = {
            sortId: this.sortID,
            fileId: this.formData.fileId,
            password: this.formData.password,
            effectiveDate: this.formData.effectiveDate,
            fileName: this.formData.fileName
          };
          try {
            await stamp.getBindingSign(params);
            this.$message.success('绑定成功');
            this.certificateDialog = false;
            await this.getFrameTree();
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    // 上传证书
    async httpUploadSign({ file }) {
      const enterpriseId = this.enterpriseId;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("enterpriseId", enterpriseId);
      try {
        const { data } = await tzService.uploadSign(formData);
        this.formData = data;
        this.$message.success('上传成功');
      } catch (e) {
        console.log(e);
      }
    },
    // 验证密码
    passwordClick() {
      this.$refs.formData.validate(async valid => {
        if (valid) {
          const params = {
            fileId: this.formData.fileId,
            password: this.formData.password
          };
          try {
            const { data } = await stamp.getCheckPassword(params);
            this.isShow = true;
            this.formData.effectiveDate = data.effectiveDate;
            this.formData.issue = data.issue;
          } catch (e) {
            console.log(e);
          }
        } else {
          return false;
        }
      });
    },
    async httpRequest({ file }) {
      const a = disablePrompt();
      if (a) {
        if (this.isStamp === 1) {
          this.$message({
            message: "已存在图章,请先删除再上传",
            type: "warning"
          });
        } else {
          const id = this.sortID;
          const formData = new FormData();
          formData.append("file", file);
          formData.append("sortId", id);
          const res = await tzService.uploadElectronic(formData);
          if (res.result === "0") {
            this.$message({
              message: "上传成功",
              type: "success"
            });
            await this.getupdatestamp();
          }
        }
        await this.getFrameTree();
      }
    },
    async getupdatestamp() {
      const id = this.sortID;
      await stamp.uploadlist(id);
    },
    async deleteStaBtn() {
      const a = disablePrompt();
      if (a) {
        const { sortCode, sortName } = this.currentRow;
        if (this.isStamp === 1) {
          await this.$confirm(`此操作将删除改${sortName}[${sortCode}]下的图章，是否继续？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
          const res = await stamp.deleteFile(this.sortID);
          if (res.result === "0") {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
          await this.getupdatestamp();
        } else {
          this.$message({
            message: "没有图章，请先上传",
            type: "warning"
          });
        }
        await this.pieView();
        await this.getFrameTree();
        this.imageUrl = 0;
        this.isStamp = 0;
      }
    },
    // 预览
    async pieView(fileID) {
      tzService.stampDownload(fileID).then((blob) => {
        this.imageUrl = URL.createObjectURL(blob);
      });
    },
    // 下载
    async download() {
      const a = disablePrompt();
      if (a) {
        if (this.isStamp === 1) {
          const fileID = this.sortID;
          tzService.stampDownload(fileID).then((blob) => {
            if (blob.type === "application/json") {
              const fileReader = new FileReader();
              fileReader.onloadend = () => {
                const jsonData = JSON.parse(fileReader.result);
                // 后台信息
                this.$message({ message: jsonData.message, type: "error" });
              };
              fileReader.readAsText(blob); // 或者读取response.data
            } else {
              if ("msSaveOrOpenBlob" in navigator) {
                // 兼容ie
                window.navigator.msSaveOrOpenBlob(blob, blob + "");
                return;
              } else {
                const link = document.createElement("a");
                link.style.display = "none";
                link.href = URL.createObjectURL(blob);
                link.setAttribute("download", blob);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }
          });
        } else {
          this.$message({
            message: "没有图章，请先上传",
            type: "warning"
          });
        }
      }
    },
    // 获取左侧模板
    getFrameTree() {
      this.frameTree = [];
      stamp.getElectronic(this.enterpriseId).then(({ data }) => {
        this.frameTree = data || [];
        if (this.frameTree.length > 0) {
          this.currentOrgChangeHandler(this.frameTree[0]);
          this.$nextTick(() => {
            this.$refs.depTree.setCurrentKey(this.frameTree[0].sortID); // 一定要加这个选中了否则样式没有出来
            this.sortID = this.frameTree[0].sortID;
          });
        }
        this.sortID = undefined;
        this.pID = undefined;
      });
    },
    // 选中左侧模板
    currentOrgChangeHandler(val) {
      console.log(val, '----');
      this.isCertificate = val.signId; // 是否展示证书信息
      this.formInfo.signId = val.signId; // 证书名称
      this.formInfo.signName = val.signName; // 证书ID
      this.formInfo.effectiveDate = val.effectiveDate; // 证书有效日期
      this.sortID = val.sortID;
      this.isStamp = val.isStamp;
      this.pID = val.pid;
      this.currentRow = val;
      this.pieView(val.sortID);
    },
    // 选中的阶段
    addstamp() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 0;
        this.$nextTick(() => {
          this.$refs.sortCode.focus();
          this.$refs.form.resetFields();
          this.form = newForm();
        });
      }
    },
    addsonStamp() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 1;
        this.$nextTick(() => {
          this.$refs.sortCode.focus();
          this.$refs.form.resetFields();
          this.form = newForm();
        });
      }
    },
    updateStamp() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        this.submitType = 2;
        this.form.sortCode = this.currentRow.sortCode;
        this.form.sortName = this.currentRow.sortName;
      }
    },
    async getstampBtn() {
      const {
        form: { sortCode, sortName },
        enterpriseId
      } = this;
      const params = { sortCode, sortName, enterpriseId };
      await this.$refs.form.validate();
      if (this.submitType === 0) {
        await stamp.insertElectronic(params);
      } else {
        params.sortID = this.sortID;
        await stamp.addElectronic(params);
      }
      await this.$message({ message: "新增成功", type: "success" });
      this.getFrameTree();
      this.getEditPersonClose();
    },
    async updatestampBtn() {
      const {
        form: { sortCode, sortName },
        enterpriseId
      } = this;
      const params = { sortCode, sortName, enterpriseId };
      params.sortID = this.sortID;
      await this.$refs.form.validate();
      const res = await stamp.updateElectronic(params);
      if (res.result === "0") {
        this.$message({
          message: "修改成功",
          type: "success"
        });
      }
      this.defaultExpandedKeys = [this.sortID];
      this.getFrameTree();
      this.getEditPersonClose();
      this.imageUrl = "";
      this.isStamp = undefined;
    },

    getEditPersonClose() {
      this.$refs.form.resetFields();
      this.editPersonDialog = false;
    },
    async deletestamp() {
      const a = disablePrompt();
      if (a) {
        const row = this.currentRow;
        await this.$confirm("此操作将删除该分类，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        if (row.pid === "0") {
          const res = await stamp.deleteElectronic(row.sortID);
          if (res.result === "0") this.$message.success("删除成功");
        } else {
          const result = await stamp.deleteChildnodes(row.sortID);
          if (result.result === "0") this.$message.success("删除成功");
        }
        this.imageUrl = "";
        this.isStamp = undefined;
        this.getFrameTree(); // 刷新列表
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 600px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_button {
      padding: var(--middle-space) var(--big-space);
    }
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 5px;
      top: $top-button-height + 15px;
      bottom: 0;
      right: 0;
      .tree_1 {
        font-size: 14px;
      }
    }
  }
  .bottom_right {
    margin-left: $left-width;
    height: 100%;
    text-align: left;
    .right_button {
      display: flex;
      align-items: center;
      padding: var(--middle-space) var(--big-space);
    }
    .right_bottom {
      width: 400px;
      height: 400px;
      margin:20px auto 0;
      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .bottom-certificate{
      width:400px;
      margin: var(--middle-space) auto;
      .certificate-style{
        font-size:14px;
        padding-top:10px;
        font-weight: 600;
        text-align: left;
        span{
          font-size:14px;
        }
      }
      .certificate-button{
        text-align: center;
        padding-top:10px;
      }
    }

  }
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
